<template>
<div class="flex-table--row mx-0 px-0">
    <div
        class="flex-table--cell"
        v-if="this.$slots.leading"
    >
        <slot name="leading" />
    </div>
    <div
        v-on:mouseenter="hover = active"
        v-on:mouseleave="hover = false"
        v-on:click="active ? $emit('click') : ''"
        v-bind:class="active ? 'cursor-pointer' : ''"
        class="flex-table--cell flex-table--cell-grow-always flex-table--cell-break-100 mx-0 px-0"
    >
        <span class="flex-table--cell-title">
            <slot name="title" />
        </span>
    </div>
    <div
        class="flex-table--cell flex-table--cell-break-50"
        v-if="this.$slots.center"
    >
        <slot name="center" />
    </div>
    <slot name="trailing">
        <div
            v-if="active"
            v-on:mouseenter="hover = active"
            v-on:mouseleave="hover = false"
            v-on:click="active ? $emit('click') : ''"
            v-bind:class="active ? 'cursor-pointer' : ''"
            class="flex-table--cell flex-table--cell-break-50"
        >
            <svg-image
                v-if="active"
                :src="'/svg/' + resource_group + '/edit.svg'"
                width="20px"
                height="25px"
                color="light-grey"
                highlight="primary"
                class="svg-img--center"
                :hover="hover"
            />
        </div>
    </slot>
</div>
</template>

<script>
export default {
    name: "ListItem",
    props: {
        active: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            hover: false,
        }
    },
}
</script>
